<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { ref } from "vue";
const currentDate = ref(new Date());
export default {
  data() {
    return {
      isPasswordVisible: false,
      title: "Bookings",
      text: "Customer",
      text1: "Bookings",
      startdate: currentDate,
      events: [],
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        headerToolbar: {
          left: "title, prev,today next",
          right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
        },
        events: [
          {
            title: "12:30am Laptop serv...",
            start: currentDate,
            textColor: "#242B3A",
            className: "fc-event-title",
          },
          {
            title: "10:00am House Clean..",
            start: "2024-09-04",
            end: "2024-09-04",
            textColor: "#242B3A",
          },
          {
            title: "11:00am Washing ...",
            start: "2024-09-05",
            end: "2024-09-05",
            textColor: "#242B3A",
          },
          {
            title: "02:00pm Toughened...",
            start: "2024-09-10",
            end: "2024-09-10",
            textColor: "#242B3A",
          },
          {
            title: "05:00pm Interior ...",
            start: "2024-09-16",
            end: "2024-09-16",
            textColor: "#242B3A",
          },
          {
            title: "01:00pm Building....",
            start: "2024-09-18",
            end: "2024-09-18",
            textColor: "#242B3A",
          },
        ],

        initialView: "dayGridMonth",
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
      },
    };
  },
  props: {
    msg: String,
  },
  components: {
    FullCalendar,
  },
  methods: {
    methods: {
      submitForm() {
        this.$router.push("/customer/user-bookings-calendar");
      },
      togglePasswordVisibility() {
        this.isPasswordVisible = !this.isPasswordVisible;
      },
    },
  },
};
</script>
<template>
  <layout-header></layout-header>
  <!-- Breadcrumb -->
  <page-breadcrumb :title="title" :text="text" :text1="text1" />
  <!-- /Breadcrumb -->
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-3 col-lg-4">
            <customer-sidebar></customer-sidebar>
          </div>
          <div class="col-xl-9 col-lg-8">
            <div
              class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
            >
              <h4>Bookings</h4>
              <div class="d-flex align-items-center">
                <p class="text-dark me-2 mb-0">Sort</p>
                <div class="dropdown me-2">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Newly Added
                  </a>
                  <div class="dropdown-menu">
                    <a href="javascript:void(0);" class="dropdown-item active"
                      >Newly Added</a
                    >
                    <a href="javascript:void(0);" class="dropdown-item">Oldest</a>
                  </div>
                </div>
                <a
                  href="javascript:void(0);"
                  class="tags d-flex justify-content-center align-items-center border rounded me-2"
                  ><i class="ti ti-calendar-month"></i
                ></a>
                <a
                  href="javascript:void(0);"
                  class="tags d-flex justify-content-center align-items-center border rounded"
                  ><i class="ti ti-filter"></i
                ></a>
              </div>
            </div>
            <div id="calendar-book">
              <FullCalendar :options="calendarOptions" :events="events"></FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <pages-footer></pages-footer>
  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
